module.exports = __webpack_public_path__ + "static/media/tiktok_white.47817ec2.svg";